module.exports = __webpack_public_path__ + "img/voicemail.ca516352.svg";